import React from "react";
import PropTypes from "prop-types";
import { getImageUrl } from "../../framework/getImageUrl";

import {
  AppBar,
  Toolbar,
  withTheme,
  Dialog,
  Slide,
  CircularProgress,
  withStyles,
  Typography,
  IconButton,
  Button,
  Divider,
} from "@material-ui/core";
import {
  Favorite,
  FavoriteBorderOutlined,
  AddCircleOutline,
  RemoveCircleOutline,
  Close,
  CloseRounded,
} from "@material-ui/icons";
import Swipe from "react-easy-swipe";
import s from "./itemView.module.css";
import globalContext from "../../context/globalContext";
import _ from "lodash";
// import FFLogo from "../../assets/ff.png";
import ffBanner from "../../assets/ff-select-banner.png";


function Transition(props) {
  return <Slide direction="right" {...props} timeout={props.timeout} />;
}

class ItemView extends React.Component {
  static contextType = globalContext;
  constructor(props) {
    super(props);
    this.state = {
      cartAdditionNumber: 0,
      imageDialogOpen: false,
      dialogItem: null,
      itemDescriptionDialogOpen: false,
    };
  }

  // comment

  toggleUpcFavorite = async (item) => {
    await this.context.global.toggleUpcFavorite(item);
    // await this.context.global.getCurrentShoppingCart()
  };

  addItem = async (item) => {
    this.setState({ cartAdditionNumber: this.state.cartAdditionNumber + 1 });
    await this.context.global.modifyShoppingCart(item, false);
  };

  removeItem = async (item) => {
    if (item.quantityInCart > 0) {
      this.setState({
        cartAdditionNumber: this.state.cartAdditionNumber - 1,
      });
    }

    await this.context.global.modifyShoppingCart(item, true);
  };

  itemViewHandleClose = async () => {
    // this.context.global.setGlobalState('itemViewDialogState', false)
    this.context.global.handleDashboardActions("BACK", "itemViewDialogState");
    this.context.global.setGlobalState("selectedItemViewCategory", null);
    this.context.global.submitShoppingCartChanges();
    this.setState({ cartAdditionNumber: 0 });
  };

  handleClick = async (text) => {
    this.setState({
      itemDescriptionDialogOpen: true,
      itemShortDecriptionText: text,
    });
  };

  handleImageDialogOpen = async (item) => {
    this.setState({
      imageDialogOpen: true,
      dialogItem: item,
    });
  };

  render() {
    const { theme, classes } = this.props;
    const {
      itemViewDialogState,
      selectedItemViewCategory,
      attributes,
    } = this.context.global.data;
    const {
      itemDescriptionDialogOpen,
      itemShortDecriptionText,
      imageDialogOpen,
      dialogItem,
    } = this.state;

    let dialogItemImageUrl;
    if (dialogItem) {
      if (dialogItem.isSelect) {
        dialogItemImageUrl = dialogItem.imageUrl;
      } else {
        dialogItemImageUrl = dialogItem.actualImageUrl;
      }
    }
    return (
      <>
        <Dialog
          fullScreen
          open={itemViewDialogState}
          onClose={this.itemViewHandleClose}
          transitionDuration={{ enter: 400, exit: 300 }}
          TransitionComponent={Transition}
          style={{ zIndex: 90002 }}
        >
          <AppBar className={s.itemViewAppBar}>
            <Toolbar className={s.itemViewToolbar}>
              <div className={s.appBarContentContainer}>
                <div className={s.addressContainer}>
                  <div className={s.itemViewCategoryName}>
                    {selectedItemViewCategory
                      ? selectedItemViewCategory.name
                      : "..."}
                  </div>
                  <div className={s.address}>
                    {selectedItemViewCategory
                      ? selectedItemViewCategory.parentCategory.name
                      : "..."}
                  </div>
                </div>
              </div>
              <div className={s.closeButtonContainer}>
                <IconButton
                  color="inherit"
                  onClick={this.itemViewHandleClose}
                  aria-label="Close"
                  className={s.itemViewAppBar}
                >
                  <Close />
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>
          <Swipe
            style={{ height: "100%" }}
            onSwipeLeft={() => this.itemViewHandleClose()}
            tolerance={50}
          >
            <div
              id={"item"}
              className={s.itemViewContainer}
              style={{
                // background: `linear-gradient(0.91turn, ${theme.palette.primary.dark} 1%, ${theme.palette.secondary.light} 99%)`
                background: `whitesmoke`,
              }}
            >
              {/* <div
                className={s.swipeInfo}
                onClick={() => this.itemViewHandleClose()}
              >
                <div>
                <IconButton
                  aria-haspopup="true"
                  onClick={() => this.openShoppingCart("down")}
                  color="inherit"
                >
                  <Badge
                    badgeContent={
                      shoppingCart
                        ? cartAdditionNumber +
                          shoppingCart.cartDetails.numberOfItems
                        : 0
                    }
                    color="secondary"
                  >
                    <ShoppingCart />
                  </Badge>
                </IconButton>
                {}
              </div>
                <div className={s.swipeInfoDirections} />
                <div className={s.swipeInfoDirections} />
                <div
                  className={s.swipeInfoDirections}
                  style={{ justifyContent: "flex-end" }}
                >
                  {isBrowser ? (
                    <div style={{ minWidth: "100px", textAlign: "center" }}>
                      Close
                    </div>
                  ) : (
                    <>
                      <ArrowBack className={s.swipeIcon} />
                    <div style={{ minWidth: "100px", textAlign: "center" }}>
                      Swipe to Close
                    </div>
                    </>
                  )}
                  <Close className={s.swipeIcon} />
                </div>
              </div> */}
              <div className={s.itemViewContent}>
                {/* <div className={s.itemViewTitle}>
                {selectedItemViewCategory
                  ? selectedItemViewCategory.name
                  : "..."}
              </div>
              <div className={s.itemViewSubTitle}>
                {selectedItemViewCategory
                  ? selectedItemViewCategory.parentCategory.name
                  : "..."}
              </div> */}

                {/* <div style={{ height: 50 }} /> */}

                {selectedItemViewCategory ? (
                  selectedItemViewCategory.calculatedInventoryItems
                    // Sort so item with price corresponding to dashboard
                    // price is shown first.
                    .slice()
                    .sort((a, b) => a.ordinalSort - b.ordinalSort)
                    .map((item) => {
                      let itemImageUrl;
                      if (item.isSelect) {
                        itemImageUrl = item.imageUrl;
                      } else {
                        itemImageUrl = item.actualImageUrl;
                      }

                      return (
                        <div key={item.uuid}>
                          <div
                            key={item.uuid}
                            className={s.itemViewItemContainer}
                            style={{
                              borderBottomColor: theme.palette.secondary.light,
                            }}
                          >
                            <div
                              className={s.itemViewItemTopBar}
                              style={{ opacity: item.savings > 0 ? 1 : 0 }}
                            >
                              <div className={s.itemViewItemTopBarLeft}>
                                save {item.savings}%
                              </div>
                              <div className={s.itemViewItemTopBarRight} />
                            </div>

                            <div className={s.item}>
                              <div className={s.itemTop}>
                                <div className={s.itemTopLeft}>
                                  <div className={s.itemTopLeftContent}>
                                    <div
                                      className={s.itemTopLeftImage}
                                      onClick={() =>
                                        this.handleImageDialogOpen(item)
                                      }
                                    >
                                      <div
                                        style={{
                                          background: `url(${getImageUrl(
                                            itemImageUrl
                                          )})`,
                                          backgroundPosition: "center",
                                          backgroundSize: "cover",
                                          minWidth: 125,
                                          maxWidth: 125,
                                          minHeight: 125,
                                          maxHeight: 125,
                                        }}
                                      >
                                        {!item.isFlagshipItem ? (
                                          <img
                                            src={`https://s3.us-east-2.amazonaws.com/ff-large-upc-webp2/FF_Select_Banner.png`}
                                            height={125}
                                            width={125}
                                            alt={ffBanner}
                                          />
                                        ) : null}
                                      </div>
                                      {/*<img src={`https://s3.us-east-2.amazonaws.com/ff-large-upc-webp2/${itemImageUrl}.jpg`} alt={''} />*/}
                                    </div>

                                    <div className={s.itemTopLeftDetails}>
                                      <div className={s.itemPriceRow}>
                                        <div
                                          className={s.itemPrice}
                                          style={{
                                            color: theme.palette.primary.main,
                                            fontWeight: 600,
                                          }}
                                        >
                                          ${(item.basePrice / 100).toFixed(2)}
                                        </div>
                                        <div
                                          className={s.itemFavorite}
                                          style={{
                                            color: theme.palette.primary.main,
                                          }}
                                          onClick={() => {
                                            this.toggleUpcFavorite(item);
                                          }}
                                        >
                                          {item.isFavorite ? (
                                            <Favorite />
                                          ) : (
                                            <FavoriteBorderOutlined />
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        className={s.itemTopLeftDetailsTitle}
                                      >
                                        {!item.isSelect ? item.brand : ""}{" "}
                                        {item.name}
                                      </div>
                                      <div className={s.sizeAndPricePerUnit}>
                                        <div
                                          className={
                                            s.itemTopLeftDetailsSizeDisplay
                                          }
                                        >
                                          {item.sizeDisplay}
                                        </div>
                                        {/* <div
                                      className={
                                        s.itemTopLeftDetailsPricePerWeight
                                      }
                                    >
                                      $
                                      {(
                                        item.basePrice /
                                        100 /
                                        item.size
                                      ).toFixed(2)}
                                      /{item.sizeUnits}
                                    </div> */}
                                      </div>
                                      <div
                                        className={
                                          s.itemTopLeftDetailsDescription
                                        }
                                        style={{ WebkitBoxOrient: "vertical" }}
                                        onClick={() =>
                                          this.handleClick(
                                            item.shortDescription
                                          )
                                        }
                                      >
                                        {
                                          item.shortDescription
                                          //   ? item.shortDescription.length < 150
                                          //     ? item.shortDescription
                                          //     : item.shortDescription.substring(
                                          //         0,
                                          //         150
                                          //       )
                                          //   : null}
                                          // <span
                                          //   style={
                                          //     item.shortDescription
                                          //       ? item.shortDescription.length <
                                          //         150
                                          //         ? {
                                          //             visibility: "hidden",
                                          //             color:
                                          //               theme.palette.primary.main
                                          //           }
                                          //         : {
                                          //             color:
                                          //               theme.palette.primary.main
                                          //           }
                                          //       : {
                                          //           visibility: "hidden",
                                          //           color:
                                          //             theme.palette.primary.main
                                          //         }
                                          //   }
                                          //   className={
                                          //     s.itemTopLeftDetailsMoreButton
                                          //   }
                                          //   onClick={() =>
                                          //     this.handleClick(
                                          //       item.shortDescription
                                          //     )
                                        }
                                        {/* > */}
                                        {/* {" "} */}
                                        {/* more... */}
                                        {/* </span> */}
                                      </div>

                                      <Dialog
                                        open={itemDescriptionDialogOpen}
                                        style={{ zIndex: 90003 }}
                                        onClick={() =>
                                          this.setState({
                                            itemDescriptionDialogOpen: false,
                                          })
                                        }
                                      >
                                        <CloseRounded
                                          style={{
                                            display: "flex",

                                            color: theme.palette.primary.main,
                                            backgroundColor: "white",
                                            boxShadow: "1px 1px 1px 1px #999",
                                            borderRadius: 20,
                                            alignSelf: "flex-end",
                                            margin: 10,
                                          }}
                                          onClick={() => {
                                            this.setState({
                                              itemDescriptionDialogOpen: false,
                                            });
                                          }}
                                        />
                                        <Typography
                                          variant={"body1"}
                                          className={classes.popover}
                                        >
                                          {itemShortDecriptionText}
                                        </Typography>
                                      </Dialog>
                                    </div>
                                  </div>

                                  <div className={s.itemTopLeftBar}>
                                    <div
                                      className={s.itemTopLeftBarBoxContainer}
                                    >
                                      <div
                                        className={s.itemTopLeftBox}
                                        style={{}}
                                      >
                                        $
                                        {(
                                          item.basePrice /
                                          100 /
                                          item.size
                                        ).toFixed(2)}
                                        /{item.sizeUnits}
                                      </div>
                                      <div className={s.itemTopLeftTitle}></div>
                                    </div>
                                    <div
                                      className={s.itemTopLeftBarBoxContainer}
                                    >
                                      <div className={s.itemTopLeftBox}>
                                        {item.calories}
                                      </div>
                                      <div className={s.itemTopLeftTitle}>
                                        calories
                                      </div>
                                    </div>
                                    <div
                                      className={s.itemTopLeftBarBoxContainer}
                                    >
                                      <div className={s.itemTopLeftBox}>
                                        {item.fat}
                                        {item.fatUnits}
                                      </div>
                                      <div className={s.itemTopLeftTitle}>
                                        fat
                                      </div>
                                    </div>
                                    <div
                                      className={s.itemTopLeftBarBoxContainer}
                                    >
                                      <div className={s.itemTopLeftBox}>
                                        {item.carbs}
                                        {item.carbsUnits}
                                      </div>
                                      <div className={s.itemTopLeftTitle}>
                                        carbs
                                      </div>
                                    </div>
                                    <div
                                      className={s.itemTopLeftBarBoxContainer}
                                    >
                                      <div className={s.itemTopLeftBox}>
                                        {item.protein}
                                        {item.proteinUnits}
                                      </div>
                                      <div className={s.itemTopLeftTitle}>
                                        protein
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                {item.quantityInCart === 0 ? (
                                  <div className={s.itemAddToCartButton}>
                                    <Button onClick={() => this.addItem(item)}>
                                      Add to cart
                                    </Button>
                                  </div>
                                ) : (
                                  <div className={s.itemRight}>
                                    <div
                                      className={s.moreItemsButton}
                                      onClick={() => this.addItem(item)}
                                    >
                                      <AddCircleOutline fontSize="large" />
                                    </div>
                                    <div className={s.numberOfItemsInCart}>
                                      {item.quantityInCart
                                        ? item.quantityInCart
                                        : 0}
                                    </div>
                                    <div
                                      className={s.lessItemsButton}
                                      onClick={() => this.removeItem(item)}
                                    >
                                      <RemoveCircleOutline fontSize="large" />
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className={s.itemBottom}>
                              {item.attributes
                                ? item.attributes.map((a) => {
                                    let aa = _.head(
                                      attributes.filter(
                                        (attr) => attr.enum === a.enum
                                      )
                                    );

                                    if (!aa.isImportant) {
                                      return null;
                                    }

                                    return (
                                      <div
                                        key={a.enum}
                                        className={
                                          s.itemAttributeImageContainer
                                        }
                                      >
                                        <img
                                          src={getImageUrl(
                                            aa.imageUrl,
                                            "ATTRIBUTE"
                                          )}
                                          alt={a.name}
                                        />
                                      </div>
                                    );
                                  })
                                : null}
                            </div>
                          </div>
                          <Divider />
                        </div>
                      );
                    })
                ) : (
                  <div style={{ textAlign: "center", margin: "2rem 0" }}>
                    <CircularProgress />
                  </div>
                )}
              </div>
            </div>
          </Swipe>
        </Dialog>
        {dialogItem ? (
          <Dialog
            open={imageDialogOpen}
            style={{ zIndex: 90003 }}
            onClick={() =>
              this.setState({
                imageDialogOpen: false,
                dialogItem: null,
              })
            }
          >
            <div
              style={{
                background: `url(${getImageUrl(dialogItemImageUrl)})`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                minWidth: "270px",
                maxWidth: "270px",
                minHeight: "270px",
                maxHeight: "270px",
              }}
            >
              {!dialogItem.isFlagshipItem ? (
                <img
                  src={`https://s3.us-east-2.amazonaws.com/ff-large-upc-webp2/FF_Select_Banner.png`}
                  height={"270px"}
                  width={"270px"}
                  alt={ffBanner}
                />
              ) : null}
            </div>
          </Dialog>
        ) : null}
      </>
    );
  }
}

ItemView.propTypes = {
  classes: PropTypes.object.isRequired,
};

const styles = (theme) => ({
  popover: {
    margin: 10,
    overflow: "scroll",
    maxHeight: "70vh",
  },
});

export default withTheme()(withStyles(styles)(ItemView));
